import { render, staticRenderFns } from "./Fudai.vue?vue&type=template&id=0c019782&scoped=true&"
import script from "./Fudai.vue?vue&type=script&lang=js&"
export * from "./Fudai.vue?vue&type=script&lang=js&"
import style0 from "./Fudai.vue?vue&type=style&index=0&id=0c019782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c019782",
  null
  
)

export default component.exports